import { Text } from "../ui";

import {
  CheckCircleIcon,
  XCircleIcon
} from "@heroicons/react/24/outline";
import {
  SasTokenInfo
} from "../services/sasTokenParser";
import { Container } from "../hooks/useContainer";

const TokenStatus = ({ token }: { token: SasTokenInfo }) => {
  return (
    <>
      {token.isValid ? (
        <CheckCircleIcon className="h-4 w-4 text-black" />
      ) : (
        <XCircleIcon className="h-4 w-4 text-red-500" />
      )}
      Token: {token.status}
      {/* {getPermissionNames(token.permissions).join(", ")} */}
    </>
  );
};

export const ContainerStatus = ({ container }: { container?: Container }) => {
  return (
    <div>
      <Text variant="note" className="flex gap-1 items-center">
        {container?.info}

        {!container?.isUninitialized() &&
          container?.sasToken &&
          TokenStatus({ token: container?.sasToken })}
      </Text>
    </div>
  );
};
